import { DateValidationError, LocalizationProvider, PickerChangeHandlerContext, PickersTextField, PickersTextFieldProps } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import React, { forwardRef, PropsWithChildren, type JSX } from 'react';
import { SideSheetFieldPropsBase } from "../side-sheet/SideSheet";
import DefaultDatePicker from "../../default-date-picker/DefaultDatePicker";
import { PickerValue } from "@mui/x-date-pickers/internals";
//import { PickerChangeHandler } from "@mui/x-date-pickers/internals/hooks/usePicker/usePickerValue";

export type SideSheetDatePickerProps = {
    value: Date;
    views?: Array<"month" | "year" | 'day'>;
    onChange?: (value: PickerValue, context: PickerChangeHandlerContext<DateValidationError>) => void;
    onAccept?: (value: PickerValue, context: PickerChangeHandlerContext<DateValidationError>) => void;
    maxDate?: Date | undefined
} & SideSheetFieldPropsBase;

export default function SideSheetDatePicker({
    id,
    testId,
    label,
    ariaLabel,
    readOnly,
    helperText,
    sx,
    disabled,
    value,
    views,
    onChange,
    onAccept,
    maxDate
}: PropsWithChildren<SideSheetDatePickerProps>): JSX.Element {

    const textField = forwardRef<HTMLDivElement, PickersTextFieldProps>((props, ref) => {
        return (
            <PickersTextField
                ref={ref}
                variant="filled"
                id={id}
                data-testid={testId}
                aria-label={ariaLabel ?? undefined}
                helperText={props.helperText}
                {...props}
                sx={{
                    marginTop: 0,
                    width: 1,
                    ...sx,
                }}
                slotProps={{
                    ...props.slotProps,
                    inputLabel: {
                        shrink: true,
                    }
                }}
            />
        );
    });

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DefaultDatePicker
                disabled={disabled}
                slotProps={{
                    textField: {
                        id: id,
                        variant: 'filled',
                        "aria-label": (ariaLabel ?? undefined),
                        helperText: helperText,
                    }
                }}
                slots={{
                    textField: textField
                }}
                label={label}
                value={value}
                readOnly={readOnly}
                onChange={(value, context) => {
                    // console.log(`@@@@ onChange value changed: ${value}, context: ${JSON.stringify(context)}`)
                    onChange?.(value, context);
                }}
                onAccept={(date: Date | null, context) => {
                    // console.log(`@@@@ onAccept value changed: ${date}, context: ${JSON.stringify(context)}`)
                    onAccept?.(date, context);
                }}
                views={views}
                maxDate={maxDate}
            />
        </LocalizationProvider>
    );
}